import { useRecoilState, useSetRecoilState } from 'recoil'
import authAtom, { IAuthState } from '../../auth.atom.ts'
import { Navigate, useLocation } from 'react-router-dom'
import { PropsWithChildren, useEffect } from 'react'
import authApi from '../../auth.api.ts'
import http, { applyInterceptors } from '../../../../services/http'
import ws from '../../../../services/ws'
import userAtom from '../../../User/user.atom.ts'
import NotificationService from '@/services/Notification/index.tsx'
import SyncHistoryProvider from '@/services/SyncHistoryProvider/index.tsx'

const AuthGate = (props: PropsWithChildren) => {
  const [authState, setAuthState] = useRecoilState(authAtom)
  const setUserState = useSetRecoilState(userAtom)
  const location = useLocation()

  useEffect(() => {
    if (import.meta.env.MODE === 'development') {
      const token = localStorage.getItem('access')
      if (token) {
        setUserState(
          (prev) =>
            ({
              ...prev,
              id: 1,
              roleId: 1,
              createdAt: '',
              updatedAt: '',
              email: 'admin',
            }) as any
        )
        const newAuthState: IAuthState = {
          authState: 'authorized' as const,
          accessToken: token,
          expires: Date.now() + 50000000,
        }

        setAuthState((prev) => ({ ...prev, ...newAuthState }))
        applyInterceptors(newAuthState, setAuthState, http, 'nsi')

        return
      }
    }

    if (authState.authState === 'unknown') {
      authApi.refreshToken().then((r) => {
        if (r.status === 'error') {
          setAuthState((prev) => ({ ...prev, authState: 'not-authorized', accessToken: '', expires: 0 }))
        } else {
          const newAuthState: IAuthState = {
            authState: 'authorized' as const,
            accessToken: r.body.auth.accessToken,
            expires: r.body.auth.expires,
          }

          setAuthState((prev) => ({
            ...prev,
            ...newAuthState,
          }))
          setUserState({ ...r.body.user, accessRights: [], isNotificationsViewed: false })

          applyInterceptors(newAuthState, setAuthState, http, 'nsi')
        }
      })
    }
  }, [])

  useEffect(() => {
    if (authState.authState !== 'authorized') return
    ws.connect({ current: authState })
  }, [authState])

  if (authState.authState === 'not-authorized') {
    return <Navigate to="/auth" replace={true} state={{ from: location }} />
  }

  return (
    <>
      <SyncHistoryProvider>
        <NotificationService />
        {props.children}
      </SyncHistoryProvider>
    </>
  )
}

export default AuthGate
